// src/portal-app/shell/kit/GroupedRows.js
//
// Label/value rows inside one card with hairline dividers — the iOS grouped
// list. Used for detail-screen sections (P5) and the More tab (P3).
import React from 'react';
import { GlassCard } from '../LiquidGlass';
import { ensureKitCss } from './kitCss';
import { IconChevron } from './icons';

export function GroupedRows({ rows }) {
    ensureKitCss();
    if (!Array.isArray(rows) || rows.length === 0) return null;

    return (
        <GlassCard className="pk-grp" data-testid="grouped-rows">
            {rows.map((row, i) => {
                const tappable = typeof row.onPress === 'function';
                const divided = i < rows.length - 1;
                const cls = [
                    'pk-grp-row',
                    divided && 'pk-grp-divided',
                    tappable && 'pk-grp-tappable',
                ].filter(Boolean).join(' ');

                const Tag = tappable ? 'button' : 'div';
                return (
                    <Tag
                        key={row.id != null ? row.id : i}
                        className={cls}
                        type={tappable ? 'button' : undefined}
                        onClick={tappable ? row.onPress : undefined}
                        data-testid={row.testId ? `grouped-row-${row.testId}` : undefined}
                    >
                        {row.icon && (
                            <span className="pk-grp-icon" aria-hidden="true">{row.icon}</span>
                        )}
                        <span className="pk-grp-label">{row.label}</span>
                        <span className="pk-row-spacer" />
                        {row.value != null && row.value !== '' && (
                            <span className="pk-grp-value pk-num" title={String(row.value)}>{row.value}</span>
                        )}
                        {tappable && (
                            <span className="pk-chev" aria-hidden="true"><IconChevron /></span>
                        )}
                    </Tag>
                );
            })}
        </GlassCard>
    );
}

export default GroupedRows;
